/*
 * След автоодобрения: размеры и шрифт — от `.pill` (base.css), форма — контур без заливки, как у
 * `AutoBadge`: это не статус (залитые пилюли заняты статусами, docs/ui-design.md §2.1).
 */
.badge {
  background: transparent;
  /* Рамка добавляет 2px высоты; паддинг ужат на столько же — строка с двумя пилюлями не прыгает. */
  padding: 3px 9px;
}

/* Одобрен без человека — акцентом: это факт о выпущенном ключе, и он обязан быть заметен. */
.issued {
  color: var(--accent-ink);
  border: 1px solid var(--violet);
}

/* Пропущен — серым: подсказка «решать вам», а не тревога. */
.skipped {
  color: var(--muted);
  border: 1px solid var(--border);
}
